import { html } from 'lit';

export const iconPlus = html`
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="9" cy="9" r="9" fill="currentColor" />
    <path
      d="M13.4688 8.75C13.4688 9.13672 13.1465 9.45898 12.7812 9.45898H9.6875V12.5527C9.6875 12.918 9.36523 13.2188 9 13.2188C8.61328 13.2188 8.3125 12.918 8.3125 12.5527V9.45898H5.21875C4.83203 9.45898 4.53125 9.13672 4.53125 8.75C4.53125 8.38477 4.83203 8.08398 5.21875 8.08398H8.3125V4.99023C8.3125 4.60352 8.61328 4.28125 9 4.28125C9.36523 4.28125 9.6875 4.60352 9.6875 4.99023V8.08398H12.7812C13.1465 8.0625 13.4688 8.38477 13.4688 8.75Z"
      fill="white"
    />
  </svg>
`;
